export const defaultEndCap = {
  title: "Deploy Realm in minutes",
  description: "Deploy an iOS, Android, or cross-platform “To Do” app with real-time sync in minutes.",
  ctaText: "Get started now",
  ctaUrl: "https://www.mongodb.com/realm/register"
}
